export default "<div echarts [options]=\"renderOptions\" style=\"height: 400px;width:100%;\"></div>";